// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuratypesCloudProvider } from './AuratypesCloudProvider';
import {
  AuratypesCloudProviderFromJSON,
  AuratypesCloudProviderFromJSONTyped,
  AuratypesCloudProviderToJSON,
  AuratypesCloudProviderToJSONTyped,
} from './AuratypesCloudProvider';

/**
 *
 * @export
 * @interface ResponseRegion
 */
export interface ResponseRegion {
  /**
   *
   * @type {AuratypesCloudProvider}
   * @memberof ResponseRegion
   */
  cloudProvider?: AuratypesCloudProvider;
  /**
   *
   * @type {string}
   * @memberof ResponseRegion
   */
  name?: string;
}

/**
 * Check if a given object implements the ResponseRegion interface.
 */
export function instanceOfResponseRegion(
  value: object,
): value is ResponseRegion {
  return true;
}

export function ResponseRegionFromJSON(json: any): ResponseRegion {
  return ResponseRegionFromJSONTyped(json, false);
}

export function ResponseRegionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseRegion {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider:
      json['cloud_provider'] == null
        ? undefined
        : AuratypesCloudProviderFromJSON(json['cloud_provider']),
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function ResponseRegionToJSON(json: any): ResponseRegion {
  return ResponseRegionToJSONTyped(json, false);
}

export function ResponseRegionToJSONTyped(
  value?: ResponseRegion | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloud_provider: AuratypesCloudProviderToJSON(value['cloudProvider']),
    name: value['name'],
  };
}
